<template>
    <rkm-area
        title="Portarias"
        type="fieldset"
    >
        <rkm-form ref="Form">
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.descricao"
                        label="Descrição"
                        uppercase
                        v-model="model.descricao"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="$refs.Form.validate(add)"
                        color="primary"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            hide-filters
            :items="data.model.portarias"
            :fields="fields"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="handleDestroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </rkm-area>
</template>

<script>
// Mixins.
import { object } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                descricao: { required: true, max: 100 }
            }
        }
    },
    data: () => ({
        model: {
            id: null,
            descricao: null,
        },
        fields: [
            { key: 'descricao', label: 'Descrição', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' }
        ]
    }),
    methods: {
        add() {

            if (this.data.model.portarias.find(p => p.descricao === this.model.descricao)) {

                this.showValidationNotification('Esta portaria já foi inclusa.')

                return
            }

            this.data.model.portarias.push(this.clone(this.model))

            this.resetForm()
        },
        resetForm() {

            this.model.id = null
            this.model.descricao = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        handleDestroy(portaria) {

            const destroy = async () => {

                this.data.model.portarias.splice(this.data.model.portarias.indexOf(portaria), 1)
            }

            this.showDeleteConfirmation('Deseja realmente excluir a portaria?', destroy)
        }
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true }
    }
}
</script>